document.addEventListener("DOMContentLoaded", function() {
  (function($) {

    // Change text of mobile label
    $(".article-sidenav__mobileLabel").html($(".article-sidenav__links.active").text());

    // listener for mobile label click
    $(".article-sidenav__mobileLabel").on('click', toggleMobileMenu);

    //sideNavPlacement();

    function toggleMobileMenu() {
      $(".article-sidenav__mobileLabel").toggleClass("active__open");
      $(".article-sidenav__links-container").slideToggle();
    }

  })(jQuery);
});
